
import Login from '@/model/Login'
import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'

const userManagementService = {
    authenticate: authenticate,
    getUserInfo: getUserInfo,
    uploadProfilePhoto: uploadProfilePhoto
}

async function authenticate(user, password) {
    return await httpClientWrapper.post('/api/login', new Login(user, password))
}

async function getUserInfo() {
    return await httpClientWrapper.get('/api/user', jwtHelper.makeHttpAuthorization())
}

async function uploadProfilePhoto(imageBlob, imageName) {
    return await httpClientWrapper.postBlob('/api/uploadProfilePhoto', imageBlob, imageName, jwtHelper.makeHttpAuthorization())
}

export default userManagementService